import styles from './Skeleton.module.css';

export interface SkeletonProps {
  /** One role="status" loading sentence for the whole skeleton. */
  label: string;
}

/**
 * Layout-matching skeleton blocks plus a single `role="status"` loading
 * sentence. The blocks are aria-hidden; the sentence is the only announced
 * part. Removed by the caller once real content arrives (no live region here).
 */
export function Skeleton({ label }: SkeletonProps) {
  return (
    <div className={styles.skeleton}>
      <p role="status" className={styles.status}>
        {label}
      </p>
      <div className={styles.blocks} aria-hidden="true">
        <span className={styles.block} data-w="title" />
        <span className={styles.block} data-w="line" />
        <span className={styles.block} data-w="line" />
        <span className={styles.block} data-w="lineShort" />
        <span className={styles.block} data-w="panel" />
      </div>
    </div>
  );
}
